import { type FC } from 'react';

import { Link, Stack, Typography } from '@mui/material';

import logo from '@/assets/logo.svg';
import { useIsMobile } from '@/hooks/useBreakpoints';
import { ArrowLeftIcon } from '@/icons';

const DOCS_URL = import.meta.env.VITE_APP_DOCS_URL;

const AboutHuFi: FC = () => {
  const isMobile = useIsMobile();

  return (
    <Stack
      sx={{
        gap: { xs: 2, md: 3 },
      }}
    >
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        sx={{ color: 'neutral.100' }}
      >
        About HuFi
      </Typography>
      <Stack
        sx={{
          px: 2,
          py: { xs: 2, md: 4 },
          bgcolor: 'background.paper',
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'border.strong',
        }}
      >
        {!isMobile && <img src={logo} alt="HuFi" width={125} />}
        <Typography
          variant="body2"
          sx={{
            color: 'neutral.100',
            mt: { xs: 0, md: 4 },
            mb: 2,
          }}
        >
          HuFi is a decentralized tradeathon organizing platform where
          communities earn rewards for holding, trading, and contributing to
          activities that support the token&apos;s growth.
        </Typography>
        <Link
          variant="body3"
          href={DOCS_URL}
          target="_blank"
          rel="noreferrer"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            width: 'fit-content',
            color: 'accent.main',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Learn More
          <ArrowLeftIcon
            sx={{ width: 24, height: 24, transform: 'rotate(135deg)' }}
          />
        </Link>
      </Stack>
    </Stack>
  );
};

export default AboutHuFi;
